<script>
import { City } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit City',
      addRoute: { name: 'Add City' },
      verboseName: 'Miasto',
      verboseNamePlural: 'Miasta',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name_pl', label: 'Nazwa (pl)' },
        { prop: 'name_en', label: 'Nazwa (en)' }
      ]
    }
  },
  computed: {
    service() {
      return City
    }
  }
}
</script>
